import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseService } from '../base.service';
import { HttpService } from '../http.service';
import { environment } from '../../environments/environment';
import { Organisation } from '../models/organisation';

@Injectable()

/**
 * Service that handles api requests for organisations
 */
export class OrganisationsService extends BaseService
{
	private api: string;

	/**
	 * OrganisationsService constructor
	 *
	 * @param {HttpService} http
	 */
	constructor(private http: HttpService)
	{
		super();
		this.api = environment.api_url;
	}

	/**
	 * Makes a get request to retrieve the current authenticated users' organisation
	 *
	 * @returns {Observable<Organisation>}
	 */
	public getOrganisation(): Observable<Organisation>
	{
		return this.http.get(this.api + 'organisations')
			.map(organisation => organisation.json() as Organisation)
	}
}



// WEBPACK FOOTER //
// ./src/app/services/organisations.service.ts